<template lang="pug">
	.asset-video-generation-info(v-if="showed && generation" v-window)
		.card
			.card-header
				i.fa.fa-film
				span Generation Info
				span.date {{new Date(generation['start_time']).toLocaleDateString()}} {{new Date(generation['start_time']).toLocaleTimeString()}}
			.card-body.collapse.show
				.form-line.generation.separator
					.videos(ref="videos")
						.video(v-for="(video, index) in generation['result_images']" @click="applyVideo(index)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Open video'}")
							video(:src="`generations/${video.fileName}`" muted preload="metadata" loop playsinline)
				AssetVideoGenerationSettings(ref="settings" :readOnly="true")
				.form-actions
					button.btn.btn-danger(type="button" @click="deleteGeneration($event)")
						i.fa.fa-remove
						span Delete generation
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 								from '../../mixins/screen'

	import AssetVideoGenerationSettings			from './AssetVideoGenerationSettings'

	export default {
		name: "AssetVideoGenerationInfo",
		mixins: [Screen],
		screen: {
			updateOn: [

			],
			events: {
				"Show AssetVideoGenerationInfo": function(variation, generation, asset) {

					this.variation = variation;
					this.generation = generation;
					this.asset = asset;

					this.creative = Creative.SelectedCreative;

					this.update();

				}
			}
		},
		components: {
			AssetVideoGenerationSettings
		},
		data() {

			this.generation = null;
			this.asset = null;

			return {

			}

		},
		methods: {
			collectData() {

				this.$nextTick(() => {

					if (this.$refs["settings"]) this.$refs["settings"].setSettings({
						vendorCodename: this.generation['vendor_codename'],
						modelCodename: this.generation['model_codename'],
						sizeCodename: this.generation['size_codename'],
						duration: this.generation['settings']?.["parameters"]?.["duration"] ?? this.generation['settings']?.["duration"],
						count: this.generation['count'],
						prompt: this.generation['prompt'],
						promptEnhancement: this.generation['prompt_enhancement']
					});

				});

			},
			applyVideo(index) {

				Broadcast.call("Show AssetVideoInfo", [this.creative, this.asset, this.variation, this.variation.videos[index]]);

			},
			deleteGeneration(e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete generation',
					message: `Are you sure you want to delete this generation?`,
					confirmButtonText: '&nbsp;&nbsp;Delete generation',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteGeneration: {
								assetGenerationId: this.generation.id
							}
						});
						this.closeWindow();
					}
				}]);

			}
		}
	}
</script>


<style lang="sass">

	.asset-video-generation-info
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			button
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				color: #fff

			.card-header
				display: flex
				flex-direction: row

				.date
					color: rgba(255,255,255,0.1)
					margin-left: auto

		.form-line
			display: flex
			flex-direction: row

		.generation
			flex-direction: column
			padding-bottom: 7px

		.videos
			display: flex
			flex-direction: row
			overflow-x: auto
			scrollbar-width: none
			-ms-overflow-style: none
			scroll-behavior: smooth

			&::-webkit-scrollbar
				display: none

			.video
				flex-shrink: 0
				width: 250px
				height: 160px
				border-radius: 5px
				overflow: hidden
				border: 1px solid var(--gray-dark)
				box-shadow: 0px 0px 5px var(--gray-dark)
				cursor: pointer
				margin-left: 10px
				background-color: #000

				&:hover
					border-color: var(--primary)

				video
					width: 100%
					height: 100%
					object-fit: contain

			.video:first-child
				margin-left: 0

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px

			.right-button
				margin-left: auto

</style>
